export var SeaAreaContent;
(function (SeaAreaContent) {
    SeaAreaContent["A1"] = "A1";
    SeaAreaContent["A2"] = "A2";
    SeaAreaContent["A3"] = "A3";
    SeaAreaContent["A4"] = "A4";
})(SeaAreaContent || (SeaAreaContent = {}));
//# sourceMappingURL=SeaAreaContent.js.map